module.exports = __webpack_public_path__ + "media/images/icons/settings-b6c6331a7df24ccd7808135625f643f5.svg";